<form class="contenedor-horario" [formGroup]="formGroup" *ngIf="!formGroup.get('eliminado').value" >
    <span class="disponibilidad-horario">Horario disponibilidad</span>

    <!-- Dias -->
    <mat-select formControlName="dia" class="dia-horario" placeholder="Día">
      <mat-option *ngFor="let helper of numSequence(listaDias.length); let diaSemana = index" [value]="diaSemana + 1">{{
        listaDias[diaSemana]
        }}</mat-option>
    </mat-select>

    <!-- Hora desde -->
    <mat-select formControlName="hora_desde" class="hora-inicial-horario" placeholder="Hora">
      <mat-option *ngFor="let hora of listaHoras" [value]="hora">{{
        hora | horaMeridiana
        }}</mat-option>
    </mat-select>

    <p class="a-horario">a</p>

    <!-- Hora hasta -->
    <mat-select formControlName="hora_hasta" class="hora-final-horario" placeholder="Hora">
      <mat-option *ngFor="let hora of listaHoras" [value]="hora">{{
        hora | horaMeridiana
        }}</mat-option>
    </mat-select>
    <span class="valor-horario">Valor reserva de espacio por hora</span>
    
    <input type="number" formControlName="valor" class="input-valor-horario" placeholder="Ingrese valor de espacio" />
    <mat-icon class="icono-eliminar" (click)="borrarHorario()">delete</mat-icon>

    <span>Estado</span>
    <div class="botones-estado">
      <button [class.boton-primario]="estado === 1" (click)="cambiarEstado(1)">Activo</button>
      <button [class.boton-primario]="estado === 0" (click)="cambiarEstado(0)">Inactivo</button>
    </div>
  </form>